// Libs
import type React from "react";
import { ErrorBoundary } from "src/components/Error/ErrorBoundary";
import { MarketingActionFeedbackBanner } from "src/components/MarketingActionFeedbackBanner/MarketingActionFeedbackBanner";
import { CapabilitiesProvider } from "src/contexts/CapabilitiesContext";
import { Layout } from "src/design-system/molecules/layout";
import TopBar from "src/layouts/SharedLayout/TopBar";

export interface GlobalLayoutProps extends React.PropsWithChildren<unknown> {
    /**
     * Additional className
     */
    className?: string;
}

export function GlobalLayout({ children }: GlobalLayoutProps): JSX.Element {
    return (
        <CapabilitiesProvider>
            <Layout header={<TopBar isFixed={false} />}>
                <MarketingActionFeedbackBanner />
                <ErrorBoundary>{children}</ErrorBoundary>
            </Layout>
        </CapabilitiesProvider>
    );
}
